/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value5: "",
    value6: "",
    value7: "",
    value8: "",
    value9: "",
    value10: "",
    value11: "",
    value12: "",
    value13: "",
    value14: "",
    value15: "",
    value16: "",
    value17: "",
    value18: "",
    value19: "",
    value20: "",
    value21: "",
    value22: "",
    value23: "",
    value24: "",
    value25: "",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue, onChangeCount }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
    onChangeCount(data.length + 28);
  }, [data]);

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
      value18: "",
      value19: "",
      value20: "",
      value21: "",
      value22: "",
      value23: "",
      value24: "",
      value25: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => setData((prev) => prev.filter((item) => item.id !== id));

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (id === item.id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">A. TÌNH HÌNH SỬ DỤNG HÓA ĐƠN BÁN HÀNG</Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={4}
                style={{ textAlign: "center", width: 10, background: "#d7d7d7", fontWeight: 800 }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                rowSpan={4}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Mã loại hóa đơn
              </Td>
              <Td
                rowSpan={4}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Ký hiệu mẫu hóa đơn
              </Td>
              <Td
                rowSpan={4}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Ký hiệu hóa đơn
              </Td>
              <Td
                rowSpan={1}
                colSpan={5}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số tồn đầu kỳ, mua / phát hành trong kỳ
              </Td>
              <Td
                rowSpan={1}
                colSpan={10}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số sử dụng, xóa bỏ, mất, hủy trong kỳ
              </Td>
              <Td
                rowSpan={1}
                colSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Tồn cuối kỳ
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Tổng số
              </Td>
              <Td
                rowSpan={2}
                colSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Sô tồn đầu kỳ
              </Td>
              <Td
                rowSpan={2}
                colSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số mua/phát hành trong kỳ
              </Td>
              <Td
                rowSpan={2}
                colSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Tổng số sử dụng, xóa bỏ, mất, hủy
              </Td>
              <Td
                rowSpan={1}
                colSpan={7}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Trong đó
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Từ số
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Đến số
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số lượng
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số lương đã sử dụng
              </Td>
              <Td
                rowSpan={1}
                colSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Xóa bỏ
              </Td>
              <Td
                rowSpan={1}
                colSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Mất
              </Td>
              <Td
                rowSpan={1}
                colSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Hủy
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Từ số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Đến số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Từ số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Đến số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Từ số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Đến số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Cộng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số lượng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số lượng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số lượng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [05]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              ></Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [06]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [07]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [08]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [09]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [10]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [11]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [12]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [13]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [14]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [15]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [16]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [17]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [18]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [19]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [20]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [21]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [22]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [23]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [24]
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                [25]
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  02GTTT
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  02GTTT
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value16"
                    value={item.value16}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value18"
                    value={item.value18}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value20"
                    value={item.value20}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value22"
                    value={item.value22}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                rowSpan={1}
                colSpan={4}
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 700 }}
              >
                Tổng cộng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "right", background: "#ddeff3", fontWeight: 700 }}
              >
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "right", background: "#ddeff3", fontWeight: 700 }}
              >
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "right", background: "#ddeff3", fontWeight: 700 }}
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftButton sx={{ mt: 2 }} variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, type, style, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
        ...style,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
